import React, { useState, useEffect } from "react";

import { IoPerson } from "react-icons/io5";

import VuiTypography from "components/VuiTypography";

import VuiBox from "components/VuiBox";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiLabel from "components/VuiLabel";
import VuiModal from "components/VuiModal";
import colors from "assets/theme/base/colors";

import moment from "moment";

import {
  DashboardGrid,
  ServerHeader,
  ServerName,
  ServerDomain,
  ServerStatus,
  ServerStatusHeader,
  ServerStatusOnline,
  ServerStatusOffline,
  InfoRow,
  InfoLabel,
  InfoValue,
} from "./styles";

function rulesHostNameColor(hostname) {
  // return "#437971";
  return "#bd0000";
}

function VuiInfoItemStations({ item }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  /*
      activated: 1
      bossRegistry: "881919"
      branch: null
      createdAt: "2023-05-03 09:49:05"
      ddd: "98"
      dddCorp: "98"
      ddi: "55"
      ddiCorp: "55"
      departmentAcronym: "SRT"
      departmentId: null
      email: "augustoboniek@gmail.com"
      emailCorp: null
      enabled: "1"
      gender: "Masculino"
      hash_reset_email: null
      hash_reset_expire: null
      id: 3
      id_group: 4
      id_individual_register: "010.326.933-98"
      id_initial: "1"
      initials: "SEDE/SRT"
      lastDateLogon: "2023-05-29 12:49:05"
      logSession: null
      login: "augusto.maciel"
      name: "Augusto Maciel"
      notify: "1"
      phone: "(98) 9998-37107"
      phoneCorp: null
      registration_velti: "892161"
      updatedAt: "2023-05-03 09:49:05"
      uuid: "e36c7c0e-e9b0-11ed-9ff5-bc2a9a88d8a6"
  */

  if (item) {
    return (
      <>
        <DashboardGrid>
          <ServerHeader>
            <ServerStatusHeader>
              <IoPerson size={32} color={rulesHostNameColor(item?.initials)} />
              <ServerName color={rulesHostNameColor(item?.initials)}>
                {item?.departmentAcronym.replace("de Ressocializacao ", "").replace("SEDE/", "")}
              </ServerName>
            </ServerStatusHeader>
          </ServerHeader>

          <InfoRow>
            <InfoLabel>Nome:</InfoLabel>
            <InfoValue>{item?.name}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>CPF:</InfoLabel>
            <InfoValue>{item?.id_individual_register}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Fone:</InfoLabel>
            <InfoValue>{item?.phone}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>E-mail:</InfoLabel>
            <InfoValue>{item?.email}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Departamento:</InfoLabel>
            <InfoValue>
              {item?.departmentAcronym.replace("de Ressocializacao ", "").replace("SEDE/", "")}
            </InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Login:</InfoLabel>
            <InfoValue>{item?.login}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Ramal:</InfoLabel>
            <InfoValue>{item?.branch || "não informado"}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Fone Funcional:</InfoLabel>
            <InfoValue>{item?.phoneCorp || "não informado"}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>E-mail Funcional:</InfoLabel>
            <InfoValue>{item?.emailCorp || "não informado"}</InfoValue>
          </InfoRow>
        </DashboardGrid>
      </>
    );
  } else {
    return <></>;
  }
}

export default VuiInfoItemStations;
